import { useQuery } from "@tanstack/react-query";

import type { OnAirEpisode } from "@/lib/episodes";
import type { ResultData } from "@/lib/metadata";
import type { Page, SiteSetting } from "@/lib/types";

import { Footer } from "../footer";
import { AboutSections } from "../home/about-sections";
import { FeaturedEpisodes } from "../home/featured-episodes";
import { Hero } from "../home/hero";
import { LivePoll } from "../home/live-poll";
import { ScheduleSection } from "../home/schedule-section";
import { Markdown } from "../page-editor-preview";

const METADATA_REFRESH_MS = 10_000;

export function HomeClientPage({
  getMetadata,
  ...props
}: {
  pages: Page[];
  settings: SiteSetting[];
  episodes: OnAirEpisode[];
  initialMetadata: ResultData | null;
  getMetadata: () => Promise<ResultData[]>;
}) {
  const { data: metadata } = useQuery({
    initialData: props.initialMetadata ? [props.initialMetadata] : [],
    initialDataUpdatedAt: 0,
    queryFn: getMetadata,
    queryKey: ["stream", "metadata"] as const,
    refetchInterval: METADATA_REFRESH_MS,
    select: (meta) => meta[0] ?? null,
  });

  return (
    <div className="min-h-[100dvh]">
      <Hero
        metadata={metadata}
        pages={props.pages}
        settings={props.settings}
        initialEpisodes={props.episodes}
      />

      <LivePoll />

      <ScheduleSection />

      <div className="py-16">
        <div className="mx-auto flex max-w-7xl flex-col gap-20 px-6 lg:px-10">
          <div className="max-w-prose">
            <Markdown
              content={
                props.pages.find((it) => it.name === "home")?.content ?? ""
              }
            />
          </div>

          <AboutSections pages={props.pages} />

          <FeaturedEpisodes />
        </div>
      </div>

      <Footer settings={props.settings} />
    </div>
  );
}
